import React from "react";
import PropTypes from "prop-types";

import "./FlipOrderRow.scss";

/*
Component

Displays its first two children as a row on wide screens,
and as a column in reverse order on narrow screens.
Does not display any other children.
*/

const FlipOrderRow = (props) => {
  const { children } = props;

  if (!children || !children.length) {
    return null;
  }

  return (
    <div className="flip-order-row">
      <div className="flip-order-child first">{children[0]}</div>

      {children[1] && (
        <div className="flip-order-child second flip-order">{children[1]}</div>
      )}
    </div>
  );
};

FlipOrderRow.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};

FlipOrderRow.defaultProps = {
  children: [],
};

export default FlipOrderRow;
